module.exports = __webpack_public_path__ + "assets/img/for-businesses.5fe743e2.jpg";